import { Slot } from "@radix-ui/react-slot"
import clsx from "clsx"
import type { MouseEventHandler, ReactNode } from "react"

import styles from "./SelectCard.module.css"

export interface SelectCardProps {
  selected: boolean
  onSelect?: MouseEventHandler<HTMLButtonElement>
  children: ReactNode
  asChild?: boolean
}

// TODO: Look at merging this into ActionListItem as they are similar
export function SelectCard(props: SelectCardProps) {
  const { selected, onSelect, children, asChild } = props
  const Component = asChild ? Slot : "button"

  return (
    <Component
      className={clsx(
        styles.cardBase,
        styles[`card-${selected ? "selected" : "default"}`],
      )}
      role="menuitemradio"
      aria-checked={selected}
      onClick={onSelect}
    >
      {children}
    </Component>
  )
}
